import { enqueueSnackbar, closeSnackbar } from "notistack"

const errorQueue = []

// 封装的函数用于显示错误信息
const toastMessage = (message, type = 'error') => {
  // 检查错误信息是否已经显示过，如果已经显示则直接返回，避免重复显示
  if (errorQueue.includes(message)) {
    return
  }

  // 添加错误信息到队列
  errorQueue.push(message)

  enqueueSnackbar(message, {
    variant: type,
    autoHideDuration: 3000,
    onClose: () => {
      // 错误信息显示完毕后，从队列中移除
      const index = errorQueue.indexOf(message)
      if (index > -1) {
        errorQueue.splice(index, 1)
      }
    }
  })
}

export default toastMessage